<template>
  <div class="social-date-picker">
    <fieldset class="date-time">
      <!--
      <b-form-datepicker 
        :id="`social-post-date-${deliverableId}`" 
        :disabled="dateTimeDisabled"
        v-model="postDate"
        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        @hidden="dateTimeUpdated"
      ></b-form-datepicker>
      -->
      <div class="date">
        <vuejs-datepicker 
          placeholder="No Date"
          v-model="postDate"
          :highlighted="highlightedDates"
          @closed="dateTimeUpdated"
          :format="displayPostDate"
        />
        <i v-if="isDateDuplicate" class="fas fa-exclamation-circle date-duplicate-icon" :id="duplicateDateTooltipId"></i>
        <b-tooltip v-if="isDateDuplicate" :target="duplicateDateTooltipId" triggers="hover">
          This date has multiple posts scheduled
        </b-tooltip>
      </div>
      <div class="time">

      	<input type="time" :id="timePickerId"  name="appt"
      	v-model="postTime"
      	:disabled="dateTimeDisabled"
      	@blur="dateTimeUpdated"
      	/>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import VueJSDatepicker from "vuejs-datepicker";

export default {
  data() {
    return {
      postDate: "",
      postTime: "",
      dateTimeDisabled: false,
      dateFormat: "YYYY-MM-DD HH:mm:ss",
    }
  },
  components: {
    "vuejs-datepicker": VueJSDatepicker,
  },
  props: ["deliverableId", "publishDate", "seriesId", "latestPost", "seriesDeliverables"],
  computed: {
    ...mapGetters([
    "deliverableDetail",
    "systemSettings",
    ]),
    postDateFormatted(){
      return this.$moment(this.postDate).format("YYYY-MM-DD");
    },
    dateIsSet(){
      if(this.postDate.length || this.postDate instanceof Date){
        return true;
      }
    },
    timeIsSet(){
      if(this.postTime.length || this.postTime instanceof Date){
        return true;
      }
    },
    highlightedDates(){
      if(this.seriesDeliverables !== undefined){
        let that = this;
        let dates = [];
        this.seriesDeliverables.forEach(function(deliverable){
          if(deliverable.publish_date !== null){
            dates.push(
              that.$moment.utc(deliverable.publish_date).local().toDate()
            )
          }
        });
        return {dates};
      }
      return {};
    },
    timePickerId(){
      if(this.deliverableId){
        return "social-post-time-"+this.deliverableId;
      }
      return "social-post-time-new-date";
    },
    isDateDuplicate(){
      let isDuplicate = false;
      if(this.seriesDeliverables){
        let that = this;
        let publishDate = this.$moment.utc(this.publishDate).local();
        for(let post of this.seriesDeliverables){
          if(that.deliverableId == post.id){
            continue;
          } else if(post.publish_date == null){
            continue;
          }
          let seriesPublishDate = that.$moment.utc(post.publish_date).local();
          if(publishDate.isSame(seriesPublishDate, 'day')){
            isDuplicate = true;
          }
        }
      }
      return isDuplicate;
    },
    duplicateDateTooltipId(){
      return "duplicate-date-"+this.deliverableId;
    }
  },
  methods: {
    dateTimeUpdated(){
      if(this.dateIsSet && this.timeIsSet){
        this.dispatchPublishDate();
      }
      else if(this.dateIsSet && !this.timeIsSet){
        let currentDateTime = this.$moment().startOf('minute');
        let nine = this.$moment("09:00:00", "HH:mm:ss");
        let midnight = this.$moment().startOf('day');
        let selectedDate = this.$moment(this.postDate).startOf('day');
        if(midnight.isSame(selectedDate)){
          if(currentDateTime.isBetween(midnight, nine)){
            this.postTime = "10:00:00"
            this.dispatchPublishDate();
          } else {
            let remainder = 15 - (currentDateTime.minute() % 15);
            this.postTime = this.$moment(currentDateTime).add(remainder, "minutes").add(2, "hours").format("HH:mm:ss");
            this.dispatchPublishDate();
          }
        } else {
          this.postTime = "10:00:00"
          this.dispatchPublishDate();
        }
      } else {
      }
      
    },
    dispatchPublishDate(){
      let that = this;
      let selection = this.postDateFormatted+" "+this.postTime;
      let utc = this.$moment(selection).utc().format(this.dateFormat);
      this.dateTimeDisabled = true;
      if(this.seriesId !== undefined && this.deliverableId === undefined){
        // New Series Post
        let returnId = this.deliverableDetail.id;
        this.$store.dispatch("updateDeliverablePublishDate", {
          social_series_id: that.seriesId,
          return_id: returnId,
          value: utc
        }).then(function(){
          that.postDate = "";
          that.postTime = "";
          that.dateTimeDisabled = false;
        });
      } else {
        // Regular Post
        let returnId = this.deliverableDetail.id;
        this.$store.dispatch("updateDeliverablePublishDate", {
          id: that.deliverableId,
          return_id: returnId,
          value: utc
        }).then(function(){
          that.dateTimeDisabled = false;
        });
      }
    },
    displayPostDate(date){
      let today = this.$moment();
      if(today.isSame(this.postDate, 'day')){
        return "Today";
      }
      return this.$moment(date).format("ddd, MMM D YYYY");
    },
  },
  created(){
    if(this.publishDate != null){
      let localPublishDate = this.$moment.utc(this.publishDate).local().format(this.dateFormat);
      if(localPublishDate != "Invalid date"){
        let localPublishArray = localPublishDate.split(" ");
        this.postDate = this.$moment(localPublishArray[0]).toDate();
        this.postTime = localPublishArray[1];
      }
    } else {
      if(this.latestPost != undefined){
        let localPublishDate = this.$moment.utc(this.latestPost.publish_date).local().format(this.dateFormat);
        if(localPublishDate != "Invalid date"){
          let localPublishArray = localPublishDate.split(" ");
          this.postTime = localPublishArray[1];
        }
      }
    }
  }

}
</script>